export default __webpack_public_path__ + "static/media/virtualTutoring.a5f9f594.png";